<template>
<div class="chapter">
<div class="inner_page">
<p class="block_8" id="calibre_pb_3"> </p>
<p class="block_9"> </p>
<p class="block_9"> </p>
<p class="block_9"> </p>
<h1 class="block_1" id="id_Toc168649515">Glossary of RomanPlace Names<br class=""/>for<br class=""/>‘The Secret Sign’</h1>
<p class="block_9"> </p>
<p class="block_9"> </p>
<table class="table_">
<tbody class="calibre5"><tr class="calibre6">
<td class="td_"><p class="block_10">Britannia</p>
</td>
<td class="td_1"><p class="block_10">Britain</p>
</td>
</tr>
<tr class="calibre6">
<td class="td_2"><p class="block_10">Camulodunum</p>
</td>
<td class="td_3"><p class="block_10">Colchester</p>
</td>
</tr>
<tr class="calibre6">
<td class="td_2"><p class="block_10">Dubris</p>
</td>
<td class="td_3"><p class="block_10">Dover</p>
</td>
</tr>
<tr class="calibre6">
<td class="td_2"><p class="block_10">Gallia</p>
</td>
<td class="td_3"><p class="block_10">France (Gaul)</p>
</td>
</tr>
<tr class="calibre6">
<td class="td_2"><p class="block_10">Hispania</p>
</td>
<td class="td_3"><p class="block_10">Spain</p>
</td>
</tr>
<tr class="calibre6">
<td class="td_2"><p class="block_10">Londinium</p>
</td>
<td class="td_3"><p class="block_10">London</p>
</td>
</tr>
<tr class="calibre6">
<td class="td_2"><p class="block_10">Melita</p>
</td>
<td class="td_3"><p class="block_10">Malta</p>
</td>
</tr>
<tr class="calibre6">
<td class="td_2"><p class="block_10">Tamesis</p>
</td>
<td class="td_3"><p class="block_10">River Thames</p>
</td>
</tr>
<tr class="calibre6">
<td class="td_2"><p class="block_10">Tiberus</p>
</td>
<td class="td_3"><p class="block_10">River Tiber</p>
</td>
</tr>
<tr class="calibre6">
<td class="td_2"><p class="block_10">Verulamium</p>
</td>
<td class="td_3"><p class="block_10">St. Albans</p>
</td>
</tr>
<tr class="calibre6">
<td class="td_4"><p class="block_10">Watling Street</p>
</td>
<td class="td_5"><p class="block_10">Mainly A2</p>
</td>
</tr>
</tbody>
</table>
<p class="block_11"> </p>
<p class="block_12"><b class="calibre7">“ICTHUS </b>= FISH in ancient Greek, the initial letters of which stand for <b class="calibre7">I</b>sous <b class="calibre7">C</b>hristos <b class="calibre7">TH</b>eou (God’s) <b class="calibre7">U</b>ios (Son) <b class="calibre7">S</b>oteros (Saviour).”<br class="calibre4" id="calibre_pb_4"/>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?15c9fb8e